import { Fetch } from '.';
import { WorkflowSavePayload } from '../types/ConfigureWorkflowTypes';
import { Metadata } from '../types/Metadata';
import { getItemStatusId } from '../utils';

export interface CreateLightUpdateRequest {
  itemId: number;
  googleDocumentId: string;
  eventType: string;
  configureWorkflow?: WorkflowSavePayload;
}

export interface UpdateEFSPersonasRequest {
  itemId: number;
  experienceId: number;
  companyDirectionId: number;
  displayOrder?: number;
}
[];

export interface GatewayResponse {
  success: boolean;
}

export const createLightUpdate =
  (f: Fetch) =>
  async (params: CreateLightUpdateRequest): Promise<GatewayResponse> => {
    const r = await f.fetchJSON<GatewayResponse>(
      params,
      process.env.CPP_CONTENT_URI + '/upsertItemGateway',
      'POST'
    );
    if (!r.success) throw new Error('Failed to create light update');
    return r;
  };

export const updateEFSPersonas =
  (f: Fetch) =>
  async (params: UpdateEFSPersonasRequest): Promise<GatewayResponse> => {
    const r = await f.fetchJSON<GatewayResponse>(
      params,
      process.env.CPP_CONTENT_URI + '/UpsertItemEfsPersonas',
      'POST'
    );
    if (!r.success) throw new Error('Failed to update EFS personas');
    return r;
  };

export const updateConfigureWorkflow =
  (f: Fetch) =>
  async (
    d: Partial<Metadata>,
    itemStatusId: number
  ): Promise<GatewayResponse> => {
    const {
      itemId,
      requestCreativeHelp,
      configureWorkflowType,
      configureWorkflowByEmpCd,
      configureWorkflowSkipIds,
      preProductionExternalReview,
      postProductionExternalReview
    } = d.props;

    const r = await f.fetchJSON<GatewayResponse>(
      {
        itemId,
        eventType: 'UPSERT_CONFIGURE_WORKFLOW',
        configureWorkflow: {
          itemStatusId,
          requestCreativeHelp,
          configureWorkflowType,
          configureWorkflowByEmpCd,
          configureWorkflowSkipIds,
          preProductionExternalReview,
          postProductionExternalReview
        }
      },
      process.env.CPP_CONTENT_URI + '/upsertItemGateway',
      'POST'
    );
    if (!r.success) throw new Error('Failed to update configure workflow');
    return r;
  };

export const updateLightUpdateConfigureWorkflow =
  (f: Fetch) =>
  async (
    d: Partial<Metadata>,
    itemStatusId: number
  ): Promise<GatewayResponse> => {
    const {
      itemId,
      requestCreativeHelp,
      configureWorkflowByEmpCd,
      configureLightUpdateWorkflowType,
      configureLightUpdateWorkflowSkipIds
    } = d.props;

    const r = await f.fetchJSON<GatewayResponse>(
      {
        itemId,
        eventType: 'UPSERT_LIGHT_UPDATE_CONFIGURE_WORKFLOW',
        configureWorkflow: {
          itemStatusId,
          requestCreativeHelp,
          configureLightUpdateWorkflowType,
          configureWorkflowByEmpCd,
          configureLightUpdateWorkflowSkipIds
        }
      },
      process.env.CPP_CONTENT_URI + '/upsertItemGateway',
      'POST'
    );
    if (!r.success)
      throw new Error('Failed to update light update configure workflow');
    return r;
  };
